// <Can> — permission-gated rendering (B5B §2.2). UI affordance only; RLS enforces
// row access server-side. PLAN-C1.9.
import { type ReactNode } from "react";
import { hasPermission, type PermissionCode } from "@sympllex/auth";
import { useSession } from "./session";

export function Can({ perm, children, fallback = null }: { perm: PermissionCode; children: ReactNode; fallback?: ReactNode }) {
  const session = useSession();
  return <>{hasPermission(session, perm) ? children : fallback}</>;
}
